import React from 'react';
import AnimateOnChange from 'react-animate-on-change';
import ExitScreen from '../../containers/ExitScreen';
import LoadingModal from '../../containers/LoadingModal';
import SharingControl from '../sharingControl/SharingControl';
import TrackSelector from '../../containers/TrackSelector';
const style = require('./modalHolder.css');
const showModalContent = (modal, hideElements) => {
    switch (modal.modalType) {
        case 'SharingControl':
            return (React.createElement("div", { className: style.exitScreen },
                hideElements.includes('sharing') ? false : React.createElement(SharingControl, { parent: "modal" }),
                React.createElement(ExitScreen, null)));
        case 'TrackSelector':
            return React.createElement(TrackSelector, null);
        case 'WaitingForItems':
            return React.createElement(LoadingModal, null);
        default:
            return false;
    }
};
const getModalStyle = modalType => {
    const styles = [style.modal];
    if (modalType === 'TrackSelector')
        styles.push(style.modalAlignTop);
    if (modalType === 'SharingControl')
        styles.push(style.exitScreen);
    return styles.join(' ');
};
const Modal = ({ modal, hideElements }) => {
    if (!modal)
        return null;
    if (modal.modalType === 'SharingControl' && hideElements.includes('exitScreen'))
        return null;
    return (React.createElement(AnimateOnChange, { baseClassName: getModalStyle(modal.modalType), animationClassName: style.showModal, animate: modal !== false },
        React.createElement("div", { className: style.holder }, showModalContent(modal, hideElements))));
};
export default Modal;
